module.exports = __webpack_public_path__ + "img/bg-login.177b6ea9.png";